import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { alertMessage } from "../../utils/AlertService";
import { REPORT_NAME, ACTION_TYPE } from "../constant/reportType";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import Loading from "../Loading";

import {
    useSaveFamilyOfficeAllocationMutation,
    useUpdateFamilyOfficeAllocationMutation,
    useGetFamilyOfficeAllocationByIdMutation,
    useBulkUploadFamilyOfficeAllocationMutation,
} from "../../redux-toolkit/services/familyOfficeAllocationService";

import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { useFindAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useFindAllAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { useFindAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { useFindAllOpportunityTypeMutation } from "../../redux-toolkit/services/opportunityTypeService";
import { useFindAllOpportunityApplicationMutation } from "../../redux-toolkit/services/opportunityApplicationService";
import { useGetAllProjectsMutation, useFindAllProjectsMutation } from "../../redux-toolkit/services/projectIntegrationService";

const ts = (d: any) => (d ? new Date(d).toISOString().split("T")[0] : "");

const FamilyOfficeAllocationData = (props: any) => {
    const localUserObj = getLocalStorageData("localUser");
    const [values, setValues] = useState<any>({});
    const [getByIdData, setGetByIdData] = useState<any>({});

    const SelectField = ({ name, label, options, labelKey = "name", valueKey = "id", handleChange, value }: any) => {
        const getLabel = (opt: any) => {
            const val = opt[labelKey] || opt.name || opt.assetRef || opt.id;
            if (typeof val === "object" && val !== null) {
                return val.name || val.code || val.projectName || val.id || JSON.stringify(val);
            }
            return val;
        };

        return (
            <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">{label}</label>
                <select className="form-select" name={name} value={value} onChange={handleChange}>
                    <option value="">-- Select {label} --</option>
                    {(options || []).map((opt: any) => (
                        <option key={opt[valueKey]} value={opt[valueKey]}>
                            {String(getLabel(opt))}
                        </option>
                    ))}
                </select>
            </div>
        );
    };

    const [activeTab, setActiveTab] = useState("manual");
    const [bulkFile, setBulkFile] = useState<File | null>(null);

    // Lookups
    const [allProjectsList, setAllProjectsList] = useState<any[]>([]);
    const [allEntities, setAllEntities] = useState<any[]>([]);
    const [allEntityTypes, setAllEntityTypes] = useState<any[]>([]);
    const [allAssets, setAllAssets] = useState<any[]>([]);
    const [allAssetTypes, setAllAssetTypes] = useState<any[]>([]);
    const [allOppTypes, setAllOppTypes] = useState<any[]>([]);
    const [allOppApps, setAllOppApps] = useState<any[]>([]);

    const [findAllProjects, allProjectsRes] = useFindAllProjectsMutation();
    const [findAllEntity, findAllEntityRes] = useFindAllEntityMasterMutation();
    const [findAllEntityType, findAllEntityTypeRes] = useFindAllEntityTypeMasterMutation();
    const [findAllAssets, findAllAssetsRes] = useFindAllAssetsMutation();
    const [findAllAssetType, findAllAssetTypeRes] = useFindAllAssetTypeMutation();
    const [findAllOppType, findAllOppTypeRes] = useFindAllOpportunityTypeMutation();
    const [findAllOppApp, findAllOppAppRes] = useFindAllOpportunityApplicationMutation();

    const [getAllProjects, getAllProjectsRes] = useGetAllProjectsMutation();

    // Mutations
    const [saveFamilyOfficeAllocation, saveRes] = useSaveFamilyOfficeAllocationMutation();
    const [updateFamilyOfficeAllocation, updateRes] = useUpdateFamilyOfficeAllocationMutation();
    const [getFamilyOfficeAllocationById, getByIdRes] = useGetFamilyOfficeAllocationByIdMutation();
    const [bulkUploadFamilyOfficeAllocation, bulkUploadRes] = useBulkUploadFamilyOfficeAllocationMutation();

    useEffect(() => {
        if (props.show) {
            const token = localUserObj?.token;
            findAllProjects({ token });
            findAllEntity({ token });
            findAllEntityType({ token });
            findAllAssets({ token });
            findAllAssetType({ token });
            findAllOppType({ token });
            findAllOppApp({ token });

            if (props.actionType === ACTION_TYPE.UPDATE_ACTION && props.data?.id) {
                getFamilyOfficeAllocationById({ token: localUserObj?.token, id: props.data.id });
            }
        }
    }, [props.show]);

    useEffect(() => { if (allProjectsRes.isSuccess) setAllProjectsList(allProjectsRes.data?.data || []); }, [allProjectsRes.isSuccess]);
    useEffect(() => { if (findAllEntityRes.isSuccess) setAllEntities(findAllEntityRes.data?.data || []); }, [findAllEntityRes.isSuccess]);
    useEffect(() => { if (findAllEntityTypeRes.isSuccess) setAllEntityTypes(findAllEntityTypeRes.data?.data || []); }, [findAllEntityTypeRes.isSuccess]);
    useEffect(() => { if (findAllAssetsRes.isSuccess) setAllAssets(findAllAssetsRes.data?.data || []); }, [findAllAssetsRes.isSuccess]);
    useEffect(() => { if (findAllAssetTypeRes.isSuccess) setAllAssetTypes(findAllAssetTypeRes.data?.data || []); }, [findAllAssetTypeRes.isSuccess]);
    useEffect(() => { if (findAllOppTypeRes.isSuccess) setAllOppTypes(findAllOppTypeRes.data?.data || []); }, [findAllOppTypeRes.isSuccess]);
    useEffect(() => { if (findAllOppAppRes.isSuccess) setAllOppApps(findAllOppAppRes.data?.data || []); }, [findAllOppAppRes.isSuccess]);

    useEffect(() => {
        if (getByIdRes.isSuccess) setGetByIdData(getByIdRes.data || {});
    }, [getByIdRes.isSuccess]);

    // Save effect
    useEffect(() => {
        if (saveRes.isSuccess) {
            alertMessage("Family Office Allocation saved", "success");
            props.setCall(Date.now().toString());
            handleClose();
        } else if (saveRes.isError) {
            alertMessage("Error saving Family Office Allocation", "error");
        }
    }, [saveRes.isSuccess, saveRes.isError]);

    // Update effect
    useEffect(() => {
        if (updateRes.isSuccess) {
            alertMessage("Family Office Allocation updated", "success");
            props.setCall(Date.now().toString());
            handleClose();
        } else if (updateRes.isError) {
            alertMessage("Error updating Family Office Allocation", "error");
        }
    }, [updateRes.isSuccess, updateRes.isError]);

    // Bulk upload effect
    useEffect(() => {
        if (bulkUploadRes.isSuccess) {
            alertMessage("Bulk upload successful", "success");
            props.setCall(Date.now().toString());
            handleClose();
        } else if (bulkUploadRes.isError) {
            alertMessage("Error during bulk upload", "error");
        }
    }, [bulkUploadRes.isSuccess, bulkUploadRes.isError]);

    const handleClose = () => props.setShow(false);

    const handleBulkUpload = () => {
        if (!bulkFile) {
            alertMessage("Please select an XLSX file first.", "error");
            return;
        }
        const formData = new FormData();
        formData.append("file", bulkFile);
        bulkUploadFamilyOfficeAllocation({ token: localUserObj?.token, payload: formData });
    };

    const getInitialValues = () => {
        const d =
            props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData : null;
        return {
            investor: d?.investor || "",
            projectId: d?.projectId || d?.project?.id || "",
            credits: d?.credits || "",
            revenueShare: d?.revenueShare || "",
            date: ts(d?.allocationDate || d?.date),
            entityId: d?.entityId || d?.entity?.id || "",
            entityTypeId: d?.entityTypeId || d?.entityType?.id || "",
            parentEntityId: d?.parentEntityId || d?.parentEntity?.id || "",
            parentEntityTypeId: d?.parentEntityTypeId || d?.parentEntityType?.id || "",
            assetId: d?.assetId || d?.assets?.id || "",
            assetTypeId: d?.assetTypeId || d?.assetType?.id || "",
            parentAssetId: d?.parentAssetId || d?.parentAsset?.id || "",
            parentAssetTypeId: d?.parentAssetTypeId || d?.parentAssetType?.id || "",
            opportunityApplicationId: d?.opportunityApplicationId || d?.opportunityApplication?.id || "",
            opportunityTypeId: d?.opportunityTypeId || d?.opportunityType?.id || "",
            planStart: ts(d?.planStart),
            planEnd: ts(d?.planEnd),
            actualStart: ts(d?.actualStart),
            actualEnd: ts(d?.actualEnd),
        };
    };

    useEffect(() => {
        if (
            (props.actionType === ACTION_TYPE.UPDATE_ACTION &&
                Object.keys(getByIdData).length > 0) ||
            props.actionType === ACTION_TYPE.ADD_ACTION
        ) {
            setValues(getInitialValues());
        }
    }, [props.actionType, getByIdData]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setValues((prev: any) => ({ ...prev, [name]: value }));
    };

    const submitHandler = () => {
        const isAdd = props.actionType === ACTION_TYPE.ADD_ACTION;
        const payload = {
            ...(isAdd ? {} : { id: props.data?.id }),
            investor: values.investor || null,
            projectId: values.projectId ? Number(values.projectId) : null,
            credits: values.credits ? parseFloat(values.credits) : null,
            revenueShare: values.revenueShare ? parseFloat(values.revenueShare) : null,
            allocationDate: values.date || null,
            entityId: values.entityId ? Number(values.entityId) : null,
            entityTypeId: values.entityTypeId ? Number(values.entityTypeId) : null,
            parentEntityId: values.parentEntityId ? Number(values.parentEntityId) : null,
            parentEntityTypeId: values.parentEntityTypeId ? Number(values.parentEntityTypeId) : null,
            assetId: values.assetId ? Number(values.assetId) : null,
            assetTypeId: values.assetTypeId ? Number(values.assetTypeId) : null,
            parentAssetId: values.parentAssetId ? Number(values.parentAssetId) : null,
            parentAssetTypeId: values.parentAssetTypeId ? Number(values.parentAssetTypeId) : null,
            opportunityApplicationId: values.opportunityApplicationId ? Number(values.opportunityApplicationId) : null,
            opportunityTypeId: values.opportunityTypeId ? Number(values.opportunityTypeId) : null,
            planStart: values.planStart || null,
            planEnd: values.planEnd || null,
            actualStart: values.actualStart || null,
            actualEnd: values.actualEnd || null,
            status: isAdd ? true : props.data?.status,
        };
        if (isAdd) {
            saveFamilyOfficeAllocation({ token: localUserObj?.token, payload });
        } else {
            updateFamilyOfficeAllocation({ token: localUserObj?.token, payload });
        }
    };

    const isLoading =
        saveRes.isLoading ||
        updateRes.isLoading ||
        bulkUploadRes.isLoading ||
        getByIdRes.isLoading;

    return (
        <Modal show={props.show} onHide={handleClose} size="lg" centered scrollable>
            <Modal.Header closeButton className="bg-cm-light-primary1 border-0">
                <Modal.Title className="text-accent fw-bold">
                    {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                    {props.reportName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loading />}

                {props.actionType === ACTION_TYPE.ADD_ACTION && (
                    <div className="d-flex mb-3 border-bottom pb-2">
                        <button
                            type="button"
                            className={`btn btn-sm me-2 ${activeTab === "manual"
                                ? "bg-accent text-white"
                                : "btn-outline-secondary"
                                }`}
                            onClick={() => setActiveTab("manual")}
                        >
                            Manual Entry
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${activeTab === "bulk"
                                ? "bg-accent text-white"
                                : "btn-outline-secondary"
                                }`}
                            onClick={() => setActiveTab("bulk")}
                        >
                            Bulk Upload
                        </button>
                    </div>
                )}

                {activeTab === "manual" ? (
                    <div className="row">
                        {/* Relation Fields */}
                        <SelectField name="entityTypeId" label="Entity Type" options={allEntityTypes} handleChange={handleChange} value={values.entityTypeId} />
                        <SelectField name="entityId" label="Entity" options={allEntities.filter(e => !values.entityTypeId || e.entityType?.id === Number(values.entityTypeId))} handleChange={handleChange} value={values.entityId} />

                        <SelectField name="assetTypeId" label="Asset Type" options={allAssetTypes} handleChange={handleChange} value={values.assetTypeId} />
                        <SelectField name="assetId" label="Asset" options={allAssets.filter(a => !values.assetTypeId || a.assetType?.id === Number(values.assetTypeId))} handleChange={handleChange} value={values.assetId} />

                        <SelectField name="opportunityTypeId" label="Opportunity Type" options={allOppTypes} handleChange={handleChange} value={values.opportunityTypeId} />
                        <SelectField name="opportunityApplicationId" label="Opportunity Application" options={allOppApps.filter(o => !values.opportunityTypeId || o.opportunityType?.id === Number(values.opportunityTypeId))} labelKey="projectName" handleChange={handleChange} value={values.opportunityApplicationId} />

                        {/* Business Fields */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Investor</label>
                            <input type="text" className="form-control" name="investor" value={values.investor || ""} onChange={handleChange} placeholder="Enter Investor Name" />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Project</label>
                            <select className="form-select" name="projectId" value={values.projectId || ""} onChange={handleChange}>
                                <option value="">-- Select Project --</option>
                                {allProjectsList?.map((opt: any) => (
                                    <option key={opt.id} value={opt.id}>{opt.projectName || opt.name || opt.id}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Credits</label>
                            <input type="number" step="any" className="form-control" name="credits" value={values.credits || ""} onChange={handleChange} placeholder="Enter Credits" />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Revenue Share (%)</label>
                            <input type="number" step="any" className="form-control" name="revenueShare" value={values.revenueShare || ""} onChange={handleChange} placeholder="Enter Revenue Share" />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Allocation Date</label>
                            <input type="date" className="form-control" name="date" value={values.date || ""} onChange={handleChange} />
                        </div>

                        {/* Timeline Fields */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Plan Start</label>
                            <input type="date" className="form-control" name="planStart" value={values.planStart} onChange={handleChange} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Plan End</label>
                            <input type="date" className="form-control" name="planEnd" value={values.planEnd} onChange={handleChange} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Actual Start</label>
                            <input type="date" className="form-control" name="actualStart" value={values.actualStart} onChange={handleChange} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">Actual End</label>
                            <input type="date" className="form-control" name="actualEnd" value={values.actualEnd} onChange={handleChange} />
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-xs-12 mb-3">
                            <label className="form-label fw-semibold">
                                Select XLSX File for {props.reportName}
                            </label>
                            <input
                                type="file"
                                className="form-control"
                                accept=".xlsx"
                                onChange={(e) =>
                                    setBulkFile(e.target.files ? e.target.files[0] : null)
                                }
                            />
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0">
                <button
                    className="btn btn-outline-secondary fw-semibold font-10 px-4"
                    onClick={handleClose}
                >
                    Close
                </button>
                {activeTab === "manual" ? (
                    <button
                        className="btn bg-accent text-white fw-semibold font-10 px-4"
                        onClick={submitHandler}
                    >
                        Submit
                    </button>
                ) : (
                    <button
                        className="btn bg-accent text-white fw-semibold font-10 px-4"
                        onClick={handleBulkUpload}
                    >
                        Upload
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default FamilyOfficeAllocationData;
